const about = {
  title: 'More on this error',
  description: 'PDF actions create, transform, and read PDF documents in-process. Inputs must be valid PDFs or PNG/JPEG images provided as base64 or binary buffers, and outputs are bounded to keep workflow runs healthy.',
  link: { text: 'Learn More', url: 'https://mindcloud.co/docs/gravity/gravity-app-builder/argument-fundamentals' }
};

export const pdfErrors = {
  PDF_UNSUPPORTED_INPUT: {
    status: 400,
    code: 'PDF_UNSUPPORTED_INPUT',
    title: 'Unsupported Input File',
    subtitle: 'UNSUPPORTED INPUT FILE',
    description: 'The provided file is not a supported input for this action. Provide a PDF (or a PNG/JPEG image for image inputs) as base64 or a binary buffer.',
    roles: {
      admin: {
        description: 'The input file content did not match any supported format for this action. The detected format is included in the error data when available.',
        about
      }
    },
    component: 'DefaultErrorPage'
  },
  PDF_INVALID_FILE: {
    status: 400,
    code: 'PDF_INVALID_FILE',
    title: 'Invalid PDF File',
    subtitle: 'INVALID PDF FILE',
    description: 'The provided PDF could not be opened. Password-protected or corrupted PDFs are not supported.',
    roles: {
      admin: {
        description: 'PDF parsing failed. This covers corrupted documents and encrypted or password-protected PDFs.',
        about
      }
    },
    component: 'DefaultErrorPage'
  },
  PDF_INPUT_TOO_LARGE: {
    status: 400,
    code: 'PDF_INPUT_TOO_LARGE',
    title: 'Input File Too Large',
    subtitle: 'INPUT FILE TOO LARGE',
    description: 'The provided file exceeds the maximum input size for PDF actions. Reduce the file size and try again.',
    roles: {
      admin: {
        description: 'The decoded input exceeded the per-file input cap for PDF actions.',
        about
      }
    },
    component: 'DefaultErrorPage'
  },
  PDF_OUTPUT_BUDGET_EXCEEDED: {
    status: 400,
    code: 'PDF_OUTPUT_BUDGET_EXCEEDED',
    title: 'Output Budget Exceeded',
    subtitle: 'OUTPUT BUDGET EXCEEDED',
    description: 'The output exceeds the page or size budget for a single step. Process a smaller page range per step: use Get PDF Info for the page count, then iterate over ranges (for example "1-10", then "11-20") and handle each batch inside the loop.',
    roles: {
      admin: {
        description: 'The action hit the per-step page cap or cumulative output byte budget. The budget exists to protect runner memory, step output storage, and downstream steps from oversized payloads.',
        about
      }
    },
    component: 'DefaultErrorPage'
  },
  PDF_PAGE_RANGE_INVALID: {
    status: 400,
    code: 'PDF_PAGE_RANGE_INVALID',
    title: 'Invalid Page Range',
    subtitle: 'INVALID PAGE RANGE',
    description: 'The provided page range could not be applied to this document. Use a format like "1-3,5" with pages that exist in the document.',
    roles: {
      admin: {
        description: 'The pages argument failed to parse or referenced pages outside the document.',
        about
      }
    },
    component: 'DefaultErrorPage'
  }
};
